export default {
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    mb: 4,
  },
  avatar: {
    width: 120,
    height: 120,
    mb: 2,
    boxShadow: 1,
    cursor: 'pointer',
    '&:hover': {
      boxShadow: 3,
      transform: 'scale(1.05)',
    },
  },
  email: {
    fontSize: 14,
    color: 'text.secondary',
  },
};
